import React, { useState } from 'react'
import { useTranslation } from "react-i18next";
import Selector from './Selector'

const LanguageSelector = () => {

    const [t, i18n] = useTranslation('common');

    const [language, setlanguage] = useState(i18n.language)
    

    const handleChange = (e) => {
        const lang = e.target.value
        i18n.changeLanguage(lang)
        setlanguage(lang)
    }

    return (
        <Selector
            label="Products per page"
            onChange={handleChange}
            value={language}
            fullWidth={false}
            color="primary"
            variant="filled"
            options={[
                { label: "English", value: "en" },
                { label: "Español", value: "es" },
            ]}
        />
    )
}

export default LanguageSelector
